<template lang="pug">
.briq-form-element
  .center
    Switches(name="toggle-switch" v-model="enabled" theme="custom" color="blue" text-enabled="enabled" text-disabled="disabled")
    | {{ label }}
    briq-tooltip(:help="help")
</template>

<script>
import Switches from 'vue-switches'

export default {
  components: { Switches },
  name: 'BriqSwitch',
  inheritAttrs: false,
  props: {
    value: Boolean,
    label: String,
    help: String,
  },
  data() {
    return { enabled: this.value }
  },
  methods: {
    toggle() {
      this.enabled = !this.enabled
      this.$emit('input', this.enabled)
    },
  },
  watch: {
    value(newVal) {
      this.enabled = newVal
    },
  },
}
</script>

<style scoped lang="stylus">
// todo: migrate styles from forms.less to here
span.icon-span
  // todo: merge this when migrating the styles from forms.less to this component
  margin-right 1em

.center
  text-align center
  background-color #F9F9F9
</style>

<style lang="stylus">
.vue-switcher-theme--custom
  &.vue-switcher--bold--unchecked
    div
      &:after
        left 26px

  &.vue-switcher-color--blue
    div
      background-color rgba(121, 134, 150, .4)

      &:after
        // for the circle on the switch
        background-color #009BFF

    &.vue-switcher--unchecked
      div
        background-color rgba(121, 134, 150, .4)

        &:after
          background-color #798696
</style>
